import styled from 'styled-components'
import { Typography } from '../../Typography'

export const StyledDeprecation = styled(Typography)`
  display: block;
  margin-bottom: 16px;
`
